import { Reply } from './replies_api'

/**
 * Pick the reply whose body should render in the single-message detail card.
 *
 * The thread's representative row (`selected`) comes from the reply-thread LIST
 * endpoint, whose serializer returns `html_body: null` by design ("use the
 * replies endpoint for full content"). Rendering the detail card straight from
 * that row drops the HTML and falls back to the plain-text body — quoted
 * From/To/Subject headers lose their bold, and the sender's hidden email
 * preheader (display:none in the HTML) surfaces as a visible duplicated line.
 *
 * The thread-detail fetch (`/emailbison/replies/`) carries the full `html_body`,
 * so prefer the matching reply from it, then the first loaded reply, and fall
 * back to the list row only while that fetch is still in flight.
 *
 * @param threadReplies - All replies in the thread (from the detail fetch),
 *   each carrying html_body.
 * @param selected - The thread's representative row from the list; returned as
 *   a fallback before the detail fetch resolves, or when nothing is selected.
 * @returns The reply to render, or undefined when nothing is selected.
 */
export function pickDetailReply(
  threadReplies: Reply[],
  selected: Reply | undefined
): Reply | undefined {
  return (
    threadReplies.find((r) => r.id === selected?.id) ??
    threadReplies[0] ??
    selected
  )
}
